module.exports = "<button class=\"scrolling-list\" id=\"btn-scrolling-list\" ng-keydown=\"vm.onKeyDown($event)\" ng-if=\"vm.items.length>0\">\n\n  <div class=\"left-arrow\" ng-if=\"vm.items.length>1\">\n      <i class=\"fa fa-lg fa-chevron-left\"></i>\n  </div>\n\n  <div class=\"itemText\">{{vm.rotationItems[1].title}}</div>\n\n  <div class=\"right-arrow\" ng-if=\"vm.items.length>1\">\n    <i class=\"fa fa-lg fa-chevron-right\"></i>\n  </div>\n  <div class=\"clearfix\"></div>\n\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/scrollingList/scrollingList.html
// module id = 56
// module chunks = 0